import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * CcfHomeIcon used to disply home icon in the navigation panel
 * @param props - SvgIconProps
 * @example -- <CcfHomeIcon />
 */
export function CcfCustomWorkspaceIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 -2 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.8 2.6C17.684 2.6 18.4 3.316 18.4 4.2V10.6C18.4 11.484 17.684 12.2 16.8 12.2H3.2C2.316 12.2 1.6 11.484 1.6 10.6V4.2C1.6 3.316 2.316 2.6 3.2 2.6H16.8ZM16.8 1H3.2C1.4328 1 0 2.4328 0 4.2V10.6C0 12.3672 1.4328 13.8 3.2 13.8H16.8C18.5672 13.8 20 12.3672 20 10.6V4.2C20 2.4328 18.5672 1 16.8 1Z" fill="#526b7a"/>
        <path d="M14.808 15.4L5.208 15.304C4.7664 15.304 4.408 15.6624 4.408 16.104C4.408 16.5456 4.7664 16.904 5.208 16.904L14.808 17C15.2496 17 15.608 16.6416 15.608 16.2C15.608 15.7584 15.2496 15.4 14.808 15.4Z" fill="#526b7a"/>
        <path d="M16.8 2.6C17.684 2.6 18.4 3.316 18.4 4.2V10.6C18.4 11.484 17.684 12.2 16.8 12.2H3.2C2.316 12.2 1.6 11.484 1.6 10.6V4.2C1.6 3.316 2.316 2.6 3.2 2.6H16.8ZM16.8 1H3.2C1.4328 1 0 2.4328 0 4.2V10.6C0 12.3672 1.4328 13.8 3.2 13.8H16.8C18.5672 13.8 20 12.3672 20 10.6V4.2C20 2.4328 18.5672 1 16.8 1Z" stroke={props.htmlColor} strokeWidth="2"/>
        <path d="M14.808 15.4L5.208 15.304C4.7664 15.304 4.408 15.6624 4.408 16.104C4.408 16.5456 4.7664 16.904 5.208 16.904L14.808 17C15.2496 17 15.608 16.6416 15.608 16.2C15.608 15.7584 15.2496 15.4 14.808 15.4Z" stroke={props.htmlColor} strokeWidth="2.3"/>
      </svg>
    </SvgIcon>
  );
}

export default CcfCustomWorkspaceIcon;
